document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".custom-lookbook-card").forEach((card) => {
      const toggleButton = card.querySelector(".custom-lookbook__products-toggle");
      const pointersWrapper = card.querySelector(".lookbook-pointers-wrapper");
  
      if (toggleButton && pointersWrapper) {
        toggleButton.addEventListener("click", function () {
          pointersWrapper.classList.toggle("active");
        });
      }

      // Prevent navigation when clicking on the pointer link
      const pointerLinks = card.querySelectorAll(".lookbook-pointer--with-link");
      pointerLinks.forEach((pointer) => {
        pointer.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
        });
      });
    });
  });
  